<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南  >  实名认证 </div>
    </div>
    <div class="auto padding250">
       <p class="title">实名认证</p>
      <div class="container ">
        <div class="formWrapper">
          <Form :label-width="80" label-position="right" class="formMin" >
            <FormItem label="姓名">
              <Input  value="" placeholder="请输入姓名"/>
            </FormItem>

            <FormItem label="身份证号 ">
              <Input  value="" placeholder="请输入身份证号"/>
            </FormItem>
            <FormItem label="身份证照片 " class="wid500">
              <Upload action="" class="upload">

                <img src="../../assets/id2.png" alt="">
                <p>身份证正面照</p>
         </Upload>
              <Upload action="" class="upload">
                <img src="../../assets/id3.png" alt="">
                <p>身份证反面照</p>

              </Upload>
            </FormItem>
            <FormItem label=" ">
              <router-link to="/zhengshuchaxun">下一步</router-link>
            </FormItem>
          </Form>
        </div>


      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .formWrapper{
    width: 330px;
    .wid500{
      width: 500px;
    }
  }

  .upload{
    text-align: center;
    font-size: 14px;
    color: #666;
    display: inline-block;
    margin-right: 40px;
    cursor: pointer;
  }
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 10px;


      a{
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #0A3C68;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changeScore/renzheng.vue